import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vip-purchase" }
const _hoisted_2 = { class: "purchase-list" }
const _hoisted_3 = { class: "item-header" }
const _hoisted_4 = { class: "header-icon" }
const _hoisted_5 = {
  key: 0,
  class: "ri-vip-crown-fill"
}
const _hoisted_6 = {
  key: 1,
  class: "ri-vip-crown-2-fill"
}
const _hoisted_7 = { class: "item-header-left" }
const _hoisted_8 = { class: "item-main" }
const _hoisted_9 = { class: "item-options" }
const _hoisted_10 = { class: "option-left" }
const _hoisted_11 = {
  key: 0,
  class: "price"
}
const _hoisted_12 = {
  key: 1,
  class: "price points"
}
const _hoisted_13 = {
  key: 2,
  class: "price"
}
const _hoisted_14 = { class: "option-right" }
const _hoisted_15 = {
  key: 0,
  class: "more-payment"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "detail-label" }
const _hoisted_18 = { class: "detail-value" }

import { ref, computed } from 'vue';
import { debounce, throttle } from '@/utils/index'

// 判断当前日期和商品序号的奇偶性是否匹配

export default /*@__PURE__*/_defineComponent({
  __name: 'vipPurchase',
  props: {
  packageList: {
    type: Array,
    default: () => []
  },
  type: {
    type: String,
    default: ''
  }
},
  emits: ['purchase'],
  setup(__props, { emit: __emit }) {

const isMatchDayAndItem = (index: number) => {
  const currentDay = new Date().getDate();
  const isDayOdd = currentDay % 2 === 1; // 判断日期是否为单数
  const isIndexOdd = (index + 1) % 2 === 1; // 判断序号是否为单数
  return isDayOdd === isIndexOdd; // 日期和序号的奇偶性相同时返回true
};


let prop = __props

let customItem = {
  name: '企业定制',
  amount: 0, // 按需报价
  isPopular: true,
  buyType: 'custom',
  goodDetailList: [
    { name: '专业', goodCount: '专属', unit: '服务' },
    { name: '资深', goodCount: '定制化', unit: '方案' },
    { name: '高效', goodCount: '专属VIP', unit: '服务' },
    { name: '全面', goodCount: '支持代运营方案，专属项目对接', unit: '' }
  ]
}

// 定义 emit 事件
const emit = __emit;
// 这里可以添加你的逻辑代码
const itemsPerRow = ref(4); // 一行显示4个item

// 计算每个item的宽度
const itemWidth = computed(() => {
  return `calc((100% - 30px) / 4)`; // 30px 是 3个间隙的总和 (10px * 3)
});

const handlePurchase = throttle((item, type) => {
  emit('purchase', item, type)
}, 300)
// 支付方式标签映射
const getPaymentLabel = (method: string) => {
  const labels = {
    money: '现金支付',
    points: '积分兑换',
    both: '现金/积分'
  }
  return labels[method] || method
}


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...__props.packageList, _unref(customItem)], (i, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["purchase-list-item", { 'popular': i.isPopular || isMatchDayAndItem(index) }]),
          key: index,
          style: _normalizeStyle({ width: itemWidth.value })
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_4, [
                (i.buyType === 'custom')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                  : (_openBlock(), _createElementBlock("i", _hoisted_6))
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", null, _toDisplayString(i.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (i.amount && [1, 3].includes(i.buyType))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "currency" }, "¥", -1)),
                      _createTextVNode(" " + _toDisplayString(i.amount / 100) + " ", 1),
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "unit" }, "/份", -1))
                    ]))
                  : _createCommentVNode("", true),
                ([2].includes(i.buyType))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-coins-line" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(i.point) + " ", 1),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "unit" }, "积分", -1))
                    ]))
                  : _createCommentVNode("", true),
                (i.buyType === 'custom')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, "按需报价"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                ([3].includes(i.buyType))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "ri-bank-card-line" }, null, -1),
                      _createTextVNode(" 支持更多支付方式 ")
                    ])))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              class: "purchase-button",
              onClick: ($event: any) => (_unref(handlePurchase)(i, __props.type))
            }, _toDisplayString(i.buyType === 'custom' ? '免费咨询' : '立即购买'), 9, _hoisted_16),
            _createVNode(_component_el_divider, {
              "border-style": "dotted",
              style: {"margin":"0","border-color":"#000"}
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.goodDetailList, (j) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item-details",
                key: j
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-checkbox-circle-fill detail-label-icon" }, null, -1)),
                  _createTextVNode(_toDisplayString(j.name), 1)
                ]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(j.goodCount) + _toDisplayString(j.unit), 1)
              ]))
            }), 128))
          ])
        ], 6))
      }), 128))
    ])
  ]))
}
}

})